<template>
    <div>
        <li class="nav-item">
            <a href="#" class="nav-link aside-menu-toggler pr-0" data-toggle="aside-menu-show">
                <i class="nav-button far fa-bell"></i>
                <span :class="[ count ? 'd-block' : 'd-none' ]" class="badge badge-danger" style="margin-left: 10px;">{{ count }}</span>
            </a>
        </li>
    </div>
</template>

<script>

import api from "../../api/notifications/notifications";

export default {
    name: "NotificationsIcon",
    data: () => ({
        count: 0,
    }),
    methods: {
        async fetchData() {
            await api.getUserNotificationsCount()
                .then(res => {
                    this.count = res.data
                })
                .catch(e => {
                    if (e.response.status === 401) {
                        this.logUser()
                    }
                })
        },
        popAlert(message) {
            this.$toast.open({
                message: message,
                type: "info",
            })
        }
    },
    created() {
        this.fetchData()
    },
    watch: {
        '$store.getters.getUserId' : function (val) {
            if (val) {
                window.Echo.private('notifications-' + this.$store.getters.getUserId)
                    .listen('Frontend\\Notification\\NewNotification', (e) => {
                        this.fetchData()
                        this.popAlert(e.message)
                    })
                    .listen('Frontend\\Notification\\NotificationUpdated', (e) => {
                        this.fetchData()
                    })
            }
        }
    },
    mounted() {
        this.$store.dispatch('loadUser')
        this.$store.dispatch('loadUserPermissions')
    }
}
</script>

<style scoped>

</style>